import React, { useEffect } from 'react';
import { Box, Stack, Text, VStack } from 'native-base';
import EscrowDetails from '../EscrowDetails';
import ShortageSummary from '../ShortageSummary';
import CenteredSubTitle from '../CenteredSubTitle';
import { escrowSummaryEntityAdapter, useEscrowDetailsQuery } from '../../../hooks';
import SummaryHeader from '../SummaryHeader';
import SurplusSummary from '../SurplusSummary';
import EscrowSkeleton from '../EscrowSkeleton';
const ESCROW_ANALYSIS_TITLE = 'Escrow Analysis Overview';
const EscrowSummary = _ref => {
  let {
    onLearnMoreClick,
    onStatementsLinkClick,
    onPayNowClick,
    logUserEvent,
    logApiEvent,
    url,
    xApiKey,
    authToken,
    loanNumber,
    state
  } = _ref;
  const {
    isLoading,
    data
  } = useEscrowDetailsQuery({
    url,
    xApiKey,
    loanNumber,
    authToken,
    logApiEvent,
    select: TData => escrowSummaryEntityAdapter(TData)
  });
  useEffect(() => {
    logUserEvent({
      action: 'EscrowAnalysisSummaryDisplayed',
      description: 'User Navigated to Escrow Analysis Summary Screen',
      type: 'EscrowAnalysisSummary'
    });
  }, [logUserEvent]);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(EscrowSkeleton, null);
  }
  return data ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VStack, {
    mx: {
      base: '2',
      md: '5',
      lg: '10'
    },
    my: 5
  }, /*#__PURE__*/React.createElement(Stack, {
    space: 5
  }, /*#__PURE__*/React.createElement(SummaryHeader, null), data.shortageOrSurplusAmount && data.shortageOrSurplusAmount > 0 ? /*#__PURE__*/React.createElement(SurplusSummary, {
    amount: Math.abs(data.shortageOrSurplusAmount),
    date: data.effectiveDate,
    state: state,
    timeFrame: data.shortageSpread
  }) : /*#__PURE__*/React.createElement(ShortageSummary, {
    amount: Math.abs(data.shortageOrSurplusAmount || 0),
    date: data.effectiveDate,
    timeFrame: data.shortageSpread
  })), /*#__PURE__*/React.createElement(CenteredSubTitle, {
    title: ESCROW_ANALYSIS_TITLE
  }), /*#__PURE__*/React.createElement(EscrowDetails, {
    data: data,
    onStatementsLinkClick: onStatementsLinkClick,
    onPayNowClick: onPayNowClick,
    onLearnMoreClick: onLearnMoreClick
  }))) : /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    testID: "no-escrow-summary"
  }, /*#__PURE__*/React.createElement(Text, null, "Sorry, something went wrong. Not able to load all data on this screen. Please try again later."));
};
export default EscrowSummary;
//# sourceMappingURL=index.js.map